import QuestionAdditionalInformationLoader from "pages/QuestionPage/QuestionAdditionalInformationLoader/QuestionAdditionalInformationLoader";

export default QuestionAdditionalInformationLoader;
